import axios from 'axios';

export async function cmsRequest(config, signal) {
  try {
    const response = await axios({ ...config, signal });
    return response.data;
  } catch (error) {
    if (signal && signal.aborted) {
      return {
        actionable: 'CONTINUE',
        code: 'USER_ABORT',
        statusCode: 'canceled',
        extraInfo: 'La petición fue cancelada por el usuario',
      };
    }
    return { error };
  }
}
